import { GlobalContext } from "components/GlobalContext";
import { useContext, useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";

// https://developer.chrome.com/en/articles/serial/

interface FilterData {
    tempVendor: number;
    tempProduct: number;
    tempId: number;
    tempLifeTotal: number;
    tempLifeCount: number;
    tempExpirationDays: number;
    tempFirstSeenMonth: number;
    tempFirstSeenDay: number;
    tempFirstSeenYear: number;
    tempSpeed1: number;
    tempSpeed2: number;
    tempSpeed3: number;
    tempSpeed4: number;
    tempFLO1Perc: number;
    tempFLO2Perc: number;
    tempFLO3Perc: number;
    tempFLO4Perc: number;
    tempFLO1val: number;
    tempFLO2val: number;
    tempFLO3val: number;
    tempFLO4val: number;
    tempExpendedPerc: number;
    tempExpiredPerc: number;
}
/*
const setupTemplate = (templateIndex: number): FilterData => {
    switch (templateIndex) {
        case 0: // standard filter
            return {
                tempVendor: 0,
                tempProduct: 0,
                tempId: Math.ceil(Math.random() * 999999),
                tempLifeTotal: 10800,
                tempLifeCount: 0,
                tempExpirationDays: 180,
                tempFirstSeenMonth: 0,
                tempFirstSeenDay: 0,
                tempFirstSeenYear: 0,
                tempSpeed1: 191,
                tempSpeed2: 137,
                tempSpeed3: 112,
                tempSpeed4: 59,
                tempFLO1Perc: 25,
                tempFLO2Perc: 50,
                tempFLO3Perc: 75,
                tempFLO4Perc: 90,
                tempFLO1val: 0,
                tempFLO2val: 0,
                tempFLO3val: 0,
                tempFLO4val: 0,
                tempExpendedPerc: 83,
                tempExpiredPerc: 92
            };
            break;

        case 1: // heavy use filter
            return {
                tempVendor: 0,
                tempProduct: 0,
                tempId: Math.ceil(Math.random() * 999999),
                tempLifeTotal: 5400,
                tempLifeCount: 0,
                tempExpirationDays: 180,
                tempFirstSeenMonth: 0,
                tempFirstSeenDay: 0,
                tempFirstSeenYear: 0,
                tempSpeed1: 191,
                tempSpeed2: 137,
                tempSpeed3: 112,
                tempSpeed4: 59,
                tempFLO1Perc: 25,
                tempFLO2Perc: 50,
                tempFLO3Perc: 75,
                tempFLO4Perc: 90,
                tempFLO1val: 0,
                tempFLO2val: 0,
                tempFLO3val: 0,
                tempFLO4val: 0,
                tempExpendedPerc: 83,
                tempExpiredPerc: 92
            }
            break;

        case 2: // near expended filter
            return {
                tempVendor: 0,
                tempProduct: 0,
                tempId: Math.ceil(Math.random() * 999999),
                tempLifeTotal: 10800,
                tempLifeCount: 8000,
                tempExpirationDays: 180,
                tempFirstSeenMonth: 0,
                tempFirstSeenDay: 0,
                tempFirstSeenYear: 0,
                tempSpeed1: 191,
                tempSpeed2: 137,
                tempSpeed3: 112,
                tempSpeed4: 59,
                tempFLO1Perc: 25,
                tempFLO2Perc: 50,
                tempFLO3Perc: 75,
                tempFLO4Perc: 90,
                tempFLO1val: 0,
                tempFLO2val: 0,
                tempFLO3val: 0,
                tempFLO4val: 0,
                tempExpendedPerc: 83,
                tempExpiredPerc: 92
            }
            break;

        case 3: // expended filter
            return {
                tempVendor: 0,
                tempProduct: 0,
                tempId: Math.ceil(Math.random() * 999999),
                tempLifeTotal: 10800,
                tempLifeCount: 10801,
                tempExpirationDays: 180,
                tempFirstSeenMonth: 0,
                tempFirstSeenDay: 0,
                tempFirstSeenYear: 0,
                tempSpeed1: 191,
                tempSpeed2: 137,
                tempSpeed3: 112,
                tempSpeed4: 59,
                tempFLO1Perc: 25,
                tempFLO2Perc: 50,
                tempFLO3Perc: 75,
                tempFLO4Perc: 90,
                tempFLO1val: 0,
                tempFLO2val: 0,
                tempFLO3val: 0,
                tempFLO4val: 0,
                tempExpendedPerc: 83,
                tempExpiredPerc: 92
            }
            break;

        case 4: // near expired filter
            return {
                tempVendor: 0,
                tempProduct: 0,
                tempId: Math.ceil(Math.random() * 999999),
                tempLifeTotal: 10800,
                tempLifeCount: 0,
                tempExpirationDays: 180,
                tempFirstSeenMonth: 180,
                tempFirstSeenDay: 0,
                tempFirstSeenYear: 0,
                tempSpeed1: 191,
                tempSpeed2: 137,
                tempSpeed3: 112,
                tempSpeed4: 59,
                tempFLO1Perc: 25,
                tempFLO2Perc: 50,
                tempFLO3Perc: 75,
                tempFLO4Perc: 90,
                tempFLO1val: 0,
                tempFLO2val: 0,
                tempFLO3val: 0,
                tempFLO4val: 0,
                tempExpendedPerc: 83,
                tempExpiredPerc: 92,
            }
            break;

        case 5: // expired filter
            return {
                tempVendor: 0,
                tempProduct: 0,
                tempId: Math.ceil(Math.random() * 999999),
                tempLifeTotal: 10800,
                tempLifeCount: 0,
                tempExpirationDays: 180,
                tempFirstSeenMonth: 196,
                tempFirstSeenDay: 0,
                tempFirstSeenYear: 0,
                tempSpeed1: 191,
                tempSpeed2: 137,
                tempSpeed3: 112,
                tempSpeed4: 59,
                tempFLO1Perc: 25,
                tempFLO2Perc: 50,
                tempFLO3Perc: 75,
                tempFLO4Perc: 90,
                tempFLO1val: 0,
                tempFLO2val: 0,
                tempFLO3val: 0,
                tempFLO4val: 0,
                tempExpendedPerc: 83,
                tempExpiredPerc: 92
            }
            break;

        case 6: // Full set STRD
            return {
                tempVendor: 99,
                tempProduct: 99,
                tempId: 5,
                tempLifeTotal: 50,
                tempLifeCount: 255,
                tempExpirationDays: 0,
                tempFirstSeenMonth: 0,
                tempFirstSeenDay: 0,
                tempFirstSeenYear: 0,
                tempSpeed1: 191,
                tempSpeed2: 137,
                tempSpeed3: 112,
                tempSpeed4: 59,
                tempFLO1Perc: 25,
                tempFLO2Perc: 50,
                tempFLO3Perc: 75,
                tempFLO4Perc: 90,
                tempFLO1val: 0,
                tempFLO2val: 0,
                tempFLO3val: 0,
                tempFLO4val: 0,
                tempExpendedPerc: 83,
                tempExpiredPerc: 92
            }
            break;

                case 7: // First boot & tests
                    tempVendor = 99;
                    tempProduct = 99;
                    tempId = 6;
                    tempLifeTotal = 50;
                    tempLifeCount = 255;
                    tempExpirationDays = 0;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 112;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 0;
                    tempFLO2val = 0;
                    tempFLO3val = 0;
                    tempFLO4val = 0;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 8: // Firt boot & tessts
                    tempVendor = 99;
                    tempProduct = 99;
                    tempId = 4;
                    tempLifeTotal = 50;
                    tempLifeCount = 255;
                    tempExpirationDays = 0;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 112;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 0;
                    tempFLO2val = 0;
                    tempFLO3val = 0;
                    tempFLO4val = 0;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 9: // Create standard filter
                    tempVendor = 99;
                    tempProduct = 99;
                    tempId = 2;
                    tempLifeTotal = 12960;
                    tempLifeCount = 0;
                    tempExpirationDays = 180;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 112;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 0;
                    tempFLO2val = 0;
                    tempFLO3val = 0;
                    tempFLO4val = 0;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 10: // First boot only
                    tempVendor = 99;
                    tempProduct = 99;
                    tempId = 1;
                    tempLifeTotal = 50;
                    tempLifeCount = 255;
                    tempExpirationDays = 0;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 112;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 0;
                    tempFLO2val = 0;
                    tempFLO3val = 0;
                    tempFLO4val = 0;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 11: // Tests only
                    tempVendor = 99;
                    tempProduct = 99;
                    tempId = 3;
                    tempLifeTotal = 0;
                    tempLifeCount = 0;
                    tempExpirationDays = 0;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 112;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 0;
                    tempFLO2val = 0;
                    tempFLO3val = 0;
                    tempFLO4val = 0;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 12: // standard flo filter
                    tempVendor = 0;
                    tempProduct = 0;
                    tempId = random(999999);
                    tempLifeTotal = 10800;
                    tempLifeCount = 0;
                    tempExpirationDays = 180;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 112;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 10;
                    tempFLO2val = 20;
                    tempFLO3val = 30;
                    tempFLO4val = 40;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 13: // invalid
                    tempVendor = 88;
                    tempProduct = 88;
                    tempId = random(999999);
                    tempLifeTotal = 10800;
                    tempLifeCount = 0;
                    tempExpirationDays = 180;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 112;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 10;
                    tempFLO2val = 20;
                    tempFLO3val = 30;
                    tempFLO4val = 40;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 14: // micro filter
                    tempVendor = 0;
                    tempProduct = 0;
                    tempId = random(999999);
                    tempLifeTotal = 10800;
                    tempLifeCount = 0;
                    tempExpirationDays = 180;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 190;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 0;
                    tempFLO2val = 0;
                    tempFLO3val = 0;
                    tempFLO4val = 0;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
        
                case 15: // micro Full set STRD 
                    tempVendor = 99;
                    tempProduct = 99;
                    tempId = 7;
                    tempLifeTotal = 50;
                    tempLifeCount = 255;
                    tempExpirationDays = 0;
                    tempFirstSeenMonth = 0;
                    tempFirstSeenDay = 0;
                    tempFirstSeenYear = 0;
        
                    tempSpeed1 = 191;
                    tempSpeed2 = 137;
                    tempSpeed3 = 170;
                    tempSpeed4 = 59;
                    tempFLO1Perc = 25;
                    tempFLO2Perc = 50;
                    tempFLO3Perc = 75;
                    tempFLO4Perc = 90;
                    tempFLO1val = 0;
                    tempFLO2val = 0;
                    tempFLO3val = 0;
                    tempFLO4val = 0;
                    tempExpendedPerc = 83;
                    tempExpiredPerc = 92;
                    break;
                }
            }
            */

const FilterProgrammer = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const [canUseSerial] = useState(() => "serial" in navigator);

    useEffect(() => {
        /*
        navigator.serial.addEventListener("connect", (event) => {
            // TODO: Automatically open event.target or warn user a port is available.
            });
            
            navigator.serial.addEventListener("disconnect", (event) => {
            // TODO: Remove |event.target| from the UI.
            // If the serial port was opened, a stream error would be observed as well.
            });
        */

        return () => {

        };
    }, []);

    const enableCommunicationsAsync = async () => {
        const port = await navigator.serial.requestPort();
        //const ports = await navigator.serial.getPorts();
        const { usbProductId, usbVendorId } = port.getInfo();
        console.log(usbProductId, usbVendorId);

        await port.open({ baudRate: 115200 });
        const textEncoder = new TextEncoderStream();
        const writableStreamClosed = textEncoder.readable.pipeTo(port.writable);
        const writer = textEncoder.writable.getWriter();
        const textDecoder = new TextDecoderStream();
        const readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
        const reader = textDecoder.readable.getReader();

        // Listen to data coming from the serial device.
        let received = "";
        while (true) {
            const { value, done } = await reader.read();
            received += value;

            if (done || received.includes('\u0004\u0003')) {
                console.log("----- Done reading 1");
                reader.releaseLock();
                break;
            }

            // value is a string.
            console.log(value);
        }

        console.log("----- Sending unlock");
        await writer.write("unlock_3&j!");

        received = "";
        while (true) {
            const { value, done } = await reader.read();
            received += value;

            if (done || received.includes('\u0004\u0003')) {
                reader.releaseLock();
                break;
            }
            // value is a string.
            console.log(value);
        }

        reader.cancel();
        await readableStreamClosed.catch(() => { /* Ignore the error */ });
        writer.close();
        await writableStreamClosed;
        await port.close();

        /*
        while (port.readable) {
            const reader = port.readable.getReader();

            try {
                while (true) {
                    const { value, done } = await reader.read();

                    if (done) {
                        // Allow the serial port to be closed later.
                        reader.releaseLock();
                        break;
                    }

                    if (value) {
                        console.log(value);
                    }
                }
            }
            catch (error) {
                // TODO: Handle non-fatal read error.
            }
        }*/

        await port.close();
    };

    return (
        <>
            {
                !canUseSerial &&
                <h2>Your browser does not support serial communications. Please use Chrome or Edge.</h2>
            }
            {
                canUseSerial &&
                <Button
                    variant="primary"
                    size="lg"
                    className=""
                    onClick={enableCommunicationsAsync}>
                    Enable Communications
                </Button>
            }
        </>
    );
}

export default FilterProgrammer;

/*
    example data from programmer over serial

    send:
        rfid_writever:01-50-10-24-21

    send: 
        rfid_read

    receive:
        Received serial command unlock_3&j!
        unlocked!
        Received serial command rfid_read
        Card UID is 94 9D 64 2E 
        Data read: pfl-00-00-593225
        Filter ID is 'pfl-00-00-593225'
        Data read: 00180-00-00-0000
        Filter Expiration is '00180-00-00-0000'
        Data read: 010800-000000-00
        Filter Life is '010800-000000-00'
        Data read: 040-040-040-040-
        Filter Speed is '040-040-040-040-'
        Data read: 25-00-50-00-83-0
        Filter Misc1 is '25-00-50-00-83-0'
        Data read: 75-00-90-00-92-0
        Filter Misc2 is '75-00-90-00-92-0'
        Data read: 94-9D-64-2E-0000
        Filter UID is '94-9D-64-2E-0000'
        Data read: 01-61-10-17-23-0
        Filter Version is '01-61-10-17-23-0'

    send:
        rfid_dump

    receive:
        Received serial command rfid_dump
        > Attempting to dump rfid tag
        ------------------------Sector 0-------------------------
        Block 0   94 9D 64 2E 43 08 04 00 62 63 64 65 66 67 68 69    ..d.C...bcdefghi
        Block 1   00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 2   00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 3   00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 1-------------------------
        Block 4   70 66 6C 2D 30 30 2D 30 30 2D 35 39 33 32 32 35    pfl-00-00-593225
        Block 5   30 30 31 38 30 2D 30 30 2D 30 30 2D 30 30 30 30    00180-00-00-0000
        Block 6   30 31 30 38 30 30 2D 30 30 30 30 30 30 2D 30 30    010800-000000-00
        Block 7   00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 2-------------------------
        Block 8   37 35 2D 30 30 2D 39 30 2D 30 30 2D 39 32 2D 30    75-00-90-00-92-0
        Block 9   32 35 2D 30 30 2D 35 30 2D 30 30 2D 38 33 2D 30    25-00-50-00-83-0
        Block 10  30 34 30 2D 30 34 30 2D 30 34 30 2D 30 34 30 2D    040-040-040-040-
        Block 11  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 3-------------------------
        Block 12  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 13  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 14  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 15  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 4-------------------------
        Block 16  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 17  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 18  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 19  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 5-------------------------
        Block 20  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 21  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 22  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 23  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 6-------------------------
        Block 24  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 25  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 26  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 27  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 7-------------------------
        Block 28  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 29  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 30  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 31  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 8-------------------------
        Block 32  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 33  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 34  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 35  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 9-------------------------
        Block 36  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 37  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 38  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 39  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 10-------------------------
        Block 40  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 41  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 42  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 43  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 11-------------------------
        Block 44  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 45  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 46  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 47  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 12-------------------------
        Block 48  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 49  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 50  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 51  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 13-------------------------
        Block 52  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 53  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 54  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 55  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 14-------------------------
        Block 56  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 57  30 31 2D 36 31 2D 31 30 2D 31 37 2D 32 33 2D 30    01-61-10-17-23-0
        Block 58  39 34 2D 39 44 2D 36 34 2D 32 45 2D 30 30 30 30    94-9D-64-2E-0000
        Block 59  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..
        ------------------------Sector 15-------------------------
        Block 60  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 61  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 62  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00    ................
        Block 63  00 00 00 00 00 00 FF 07 80 69 43 6F B1 22 EB 1F    .........iCo."..


Misc dev unlock procedures

  First, to speak to the utility using the full dev suite of tools, you'll need to run arduino
  choose the port of the device you're trying to speak to, and open the serial monitor.

  Once the serial monitor is open, take a look at the bottom of the window and ensure that the 
  baud rate is set to "115200" (bottom right of the window, dropdown box with numbers that say xxx baud) 
  and the line ending is set to "newline" (dropdown box to the left of the baud rate dropdown)

  At this point, you should be able to unlock dev mode by entering "unlock_3&j!" (omit the quotes) 
  and hitting enter to send the command.

  The dev mode is now unlocked on the device. At this point you can do anything the device can do.
  In order to relock the device, just send "lock" or "restart" to restart the device which will 
  nautrally relock it.

  Basic data retreival:

  "rfid_read"
    This will pull the following data:
      Filter ID
        pfl-vv-pp-iiiiii
        vv = 2 digit vendor code
        pp = 2 digit product code
        iiiiii = 6 digit id

      Expiration
        deded-fm-fd-fyfy
          deded = 5 digit days to expire
          fm = 2 digit first month (00 = unit sets on first read of filter)
          fd = 2 digit first day (00 = unit sets on first read of filter)
          fyfy = 4 digit first year (0000 = unit sets on first read of filter)

      Life
        mflmfl-cflcfl-xx
          mflmfl = 6 digit max filter life
          cflcfl = 6 digit current filter life
          xx = unused 2 character space

      Speeds
        sp1-sp2-sp3-sp4-
          sp1 = 3 digit first speed
          sp2 = 3 digit second speed
          sp3 = 3 digit third speed (this is the default speed)
          sp4 = 3 digit fourth speed (a 0 here means there is no turbo speed)

      Misc1
        p1-v1-p2-v2-lp-i
          p1 = 2 digit filter life offset 1 min percentage
          v1 = 2 digit filter life offset 1 value
          p2 = 2 digit filter life offset 2 min percentage
          v2 = 2 digit filter life offset 2 value
          lp = 2 digit expend warn min percentage
          i = 1 digit write device id (0 = utility, 1 = unit)

      Misc2
        p3-v3-p4-v4-lp-x
          p3 = 2 digit filter life offset 3 min percentage
          v3 = 2 digit filter life offset 3 value
          p4 = 2 digit filter life offset 4 min percentage
          v4 = 2 digit filter life offset 4 value
          lp = 2 digit expire warn min percentage
          x = single unused character
      
      UID Check
        u0-u1-u2-u3-xxxx 
          u0 = 2 character first uid position
          u1 = 2 character second uid position
          u2 = 2 character third uid position
          u3 = 2 character fourth uid position
          xxxx = four unused characters

      Version
        MV-mv-mm-dd-yy
          MV = 2 digit major firmware version of the write device
          mv = 2 digit minor firmware versio nof the write device
          mm = 2 digit month of date written originally (no updated on filter incremental updates)
          dd = 2 digit day of date written originally (no updated on filter incremental updates)
          yy = 2 digit year of date written originally (no updated on filter incremental updates)

    "rfid_dump"
      This will do a complete dump of every block / sector on the rfid tag.
      This is a good way to ensure all the access codes are correct on the tag (ensure we can read every block / sector properly)

    "rfid_clear"
      This is not often needed, but it will clear all (safe) blocks and sectors on a pfl formatted tag

    "rfid_dtopfl"
      This will take a tag with default access codes and format it to be a pfl tag

    "rfid_writever"
      Manually write the version block of the tag
      "rfid_writever:01-50-10-24-21" would write:
        Major version 01
        Minor version 50
        Month 10
        Day 24
        Year 2021

    "rfid_writeid"
      Manually write the filter id block of the tag
      "rfid_writeid:pfl-99-99-000001" writes a special id to revert to first boot
      "rfid_writeid:pfl-99-99-000002" writes a special id to reset another filter's life & expiration
      "rfid_writeid:pfl-99-99-000003" writes a special id to run tests
      "rfid_writeid:pfl-99-99-000004" writes a special id to run tests & revert to first boot
      "rfid_writeid:pfl-99-99-000005" writes a special id to full set STRD (unit test, update clock to version date, reset unit, reset tag to standard)
      "rfid_writeid:pfl-99-99-000006" writes a special id to full set Heavy (unit test, update clock to version date, reset unit, reset tag to heavy)
      "rfid_writeid:pfl-99-99-000007" writes a special id to update clock to version date

    "rfid_writeexpiration"
      Manually write the filter expiration block of the tag
      "rfid_writeexpiration:00999-00-00-0000" writes an expiration for 999 days, lets the unit write the month / day / year on first read

    "rfid_writelife"
      Manually write the life block of the tag
      "rfid_writelife:000999-000000" writes a life with 999 life cycles and 0 currently used

    "rfid_writespeed"
      Manually write the speed block of the tag
      "rfid_writespeed:010-020-030-040-" writes speeds of 10, 20, 30 and 40

    "rfid_writemisc1"
      Manually write the first misc block of the tag
      "rfid_writemisc1:10-01-20-02-33-0" writes a tag with a flo1 % of 10 and a flo1 value of 1, flo2 % of 20 flo2 value of 2, an expend warning after 33% and a writer id of 0 (rfid utility)

    "rfid_writemisc2"
      "rfid_writemisc2:30-03-40-04-55-0" writes a tag with a flo3 % of 30 and a flo3 value of 3, flo4 % of 40 flo2 value of 4 and an expire warning after 55% 

    "wifi_creds"
      Stores wifi credentials for the device to log into on boot for setting the clock automatically on every start
      "wifi_creds:my_ssid|my_pass"

    "wifi_disable"
      Clears the stored wifi credentials so the device will no longer attempt to get online and sync the clock on startup
*/